import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { line } from 'd3-shape';
export var getPoints = function getPoints(data, xScale, yScale) {
  var fn = line().x(function (d) {
    return xScale(d);
  }).y(function (d) {
    return yScale(d);
  });
  return fn(data);
};

var ChartLine = function ChartLine(_ref) {
  var className = _ref.className,
      data = _ref.data,
      xScale = _ref.xScale,
      yScale = _ref.yScale;
  return React.createElement("g", null, React.createElement("path", {
    stroke: "#000",
    className: cx('ChartLine', className),
    d: getPoints(data, xScale, yScale)
  }));
};

ChartLine.displayName = 'ChartLine';
ChartLine.propTypes = {
  data: PropTypes.array.isRequired,
  className: PropTypes.string.isRequired,
  xScale: PropTypes.func.isRequired,
  yScale: PropTypes.func.isRequired
};
export default ChartLine;